import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { Matrix } from '../../../platform/geom/Matrix';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Physical } from '../../canvas/entities/Physical';
import { Physicals } from '../../canvas/entities/Physicals';
import { VisualConfiguration } from '../../canvas/visualization/VisualConfiguration';

export const Scene = styled.div<{ scale?: any }>`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    transform: scale(${p => p.scale ?? '1'});
    pointer-events: none;
`;

const Frame = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #F6FAFD;
`;

const Origin = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    pointer-events: none;`
    ;

const Mount: LFC<{ object: Physical }> = ({ object }) => {
    const Visual = VisualConfiguration[object.type];
    return !!Visual ? <Visual disposition={{ effects: {} }} object={object} /> : null;
};

export const AutoScene: LFC<{ pad?: number, objects: Physical[] }> = ({ pad, objects }) => {

    const [frame, setFrame] = useState<HTMLDivElement>();
    const [transform, setTransform] = useState(null as Matrix);

    useEffect(() => {
        if (!frame) return;

        pad = pad ?? 0.8;
        const bounds = Physicals.bounds(objects);
        const view = Rect.fromElement(frame);

        const offset = new Point(
            bounds.width * -.5,
            bounds.height * -.5,
        );

        const translate = offset.subtract(bounds.topLeft());

        const scale = Math.min(
            (view.width * pad) / bounds.width,
            (view.height * pad) / bounds.height
        );

        setTransform(Matrix.scale(scale).translate(translate));

    }, [objects, frame]);

    return <Frame ref={setFrame} >
        {transform && <Origin style={{ transform: transform.toCSS() }}>
            {objects.map(o => <Mount key={o.id} object={o} />)}
        </Origin>}
    </Frame>;
};
